import { render, staticRenderFns } from "./compWithdrawalConfig.vue?vue&type=template&id=02709b35&scoped=true&"
import script from "./compWithdrawalConfig.vue?vue&type=script&lang=js&"
export * from "./compWithdrawalConfig.vue?vue&type=script&lang=js&"
import style0 from "./compWithdrawalConfig.vue?vue&type=style&index=0&id=02709b35&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02709b35",
  null
  
)

export default component.exports